export default "__VITE_ASSET__6290e6cf__";